import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { User, Role } from 'app/componentes/auth/models';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Conexiones } from 'app/conexiones';
import { getToken } from 'app/componentes/clases/sessions-utils';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  //public Conexion:Conexiones;
  public currentUser: Observable<User>;
  public token: string;
  private currentUserSubject: BehaviorSubject<User>;
  private headers:any = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'responseType': 'json',
  };

  constructor(
    private http: HttpClient,
    private router: Router
  ){
    this.token = getToken();
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    //this.Conexion = new Conexiones();
  }
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  buildHeaderToken(){
    this.headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'responseType': 'json',
      'Authorization': `Bearer ${this.token}`,
    };
  }

  validateToken(params:any){
    //this.Conexion.getConexion();
    this.token = params.token;
    this.buildHeaderToken();
   // return this.http.post(this.Conexion.URLAPI+'validateToken', params, { headers: this.headers });
  }

  login(email: string, password: string) {
  }

  logout() {
    localStorage.clear();
    this.currentUserSubject.next(null);
    this.router.navigate(['/']);
  }
}
